import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import { DataValueViews } from "abreact/data/DataValueViews";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export function AbStringDataValueInput(props) {
  // Hack: Turn off dynamic validation issues publishing, as the child input renderer will take care of that.
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-string-data-value-input", {
    ...props,
    publishDynamicValidationIssues: false
  });
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  const singleLine = props.singleLine || props.accessor.constraints?.singleLine === true;
  const name = props.name ?? props.accessor.name;
  const onChange = (newSubject, newString) => {
    viewModel.changeValue(newString !== "" ? newString : null);
  };
  let viewProvider = DataValueViews.getViewProvider(viewModel.accessor.dataType);
  let inputRenderer = viewProvider.renderInput;
  if (!inputRenderer && viewModel.accessor.dataType.rawType) {
    viewProvider = DataValueViews.getViewProvider(viewModel.accessor.dataType.rawType);
    inputRenderer = viewProvider.renderInput;
  }
  if (!inputRenderer) {
    throw new Error(`Cannot render input as data type "${viewModel.accessor.dataType.name}" does not declare a renderInput method`);
  }

  // Render as inactive if the component is editable and being shown in edit mode, but yet it isn't editing.
  // This means that the user is trying to edit the data value, but they don't have editing permissions.
  const isInactive = !viewModel.isEditing && !props.readOnly && viewModel.isInEditMode;
  return !viewModel.isEditing ? currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", viewModel.readOnlyProps, props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: currentValue,
    inactive: isInactive
  })) : inputRenderer({
    ...viewModel.inputProps,
    publishDynamicValidationIssues: props.publishDynamicValidationIssues,
    // Undo hack above
    name: name,
    currentValue: StringUtils.emptyIfNull(currentValue),
    onChange: onChange,
    singleLine: singleLine
  });
}
//# sourceMappingURL=AbStringDataValueInput.js.map
